/**
 * MarketplaceRoute - Auth-aware marketplace route switching
 *
 * GW-1694: Renders the public version of marketplace pages for unauthenticated users,
 * and the authenticated version for signed-in users.
 *
 * GW-1737: Authenticated users get the full application chrome (Sidebar + Header).
 * GW-1754: Public view uses unified Header for consistent navigation across auth states.
 *
 * GW-10436/GW-10515: Chrome lives in the unified AppLayout shell. This component's sole
 * responsibility is swapping the page COMPONENT (authenticatedElement vs publicElement)
 * by auth state — the AppLayout ancestor is the parent layout route in marketplace.routes.tsx,
 * placed OUTSIDE the Suspense boundary so the shell never unmounts during lazy-load (GW-13841).
 */

import { type ReactElement } from 'react';

import { useAuthStore } from '@/stores/store';

interface MarketplaceRouteProps {
  authenticatedElement: ReactElement;
  publicElement: ReactElement;
}

export function MarketplaceRoute({ authenticatedElement, publicElement }: MarketplaceRouteProps) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? authenticatedElement : publicElement;
}
